<article
  ref="live_feed_card"
  class="card h-100 w-100 border shadow-sm rounded-2 p-3 d-flex flex-column live-feed-shell"
>
  <div class="d-flex align-items-start justify-content-between gap-3 mb-3">
    <div class="min-w-0">
      <p class="text-uppercase text-secondary text-xxs fw-bold mb-1">Live Feed</p>
      <h6 class="fw-bold mb-1 d-flex align-items-center gap-2">
        <i class="bi bi-camera-video-fill text-danger"></i>
        {{ camera_label }}
      </h6>
      <p class="text-secondary text-xs mb-0 text-truncate">{{ selected_location_name }}</p>
    </div>

    <div class="d-flex align-items-center gap-2 flex-shrink-0">
      <span class="badge rounded-pill bg-success-subtle text-success-emphasis d-inline-flex align-items-center gap-1">
        <span class="bcx-live-dot"></span>
        Live
      </span>

      <button
        type="button"
        class="btn btn-sm btn-outline-secondary rounded-circle d-inline-flex align-items-center
               justify-content-center p-2"
        :title="is_fullscreen ? 'Exit fullscreen' : 'View fullscreen'"
        @click="toggle_fullscreen"
      >
        <i :class="is_fullscreen ? 'bi bi-fullscreen-exit' : 'bi bi-fullscreen'"></i>
      </button>
    </div>
  </div>

  <div class="live-feed-frame position-relative overflow-hidden rounded-2 border bg-dark">
    <video
      v-if="should_show_video"
      ref="video"
      :key="video_key"
      class="live-feed-image"
      controls
      autoplay
      muted
      playsinline
      @loadeddata="mark_feed_loaded"
      @error="mark_feed_failed"
    ></video>

    <iframe
      v-else-if="stream_url && !image_failed && render_mode === 'iframe'"
      :src="live_feed_src"
      :title="camera_label"
      class="live-feed-image border-0"
      allow="autoplay; fullscreen; picture-in-picture"
      allowfullscreen
      @error="mark_feed_failed"
      @load="mark_feed_loaded"
    ></iframe>

    <img
      v-else-if="stream_url && !image_failed"
      :src="live_feed_src"
      :alt="`${camera_label} footage for ${selected_location_name}`"
      class="live-feed-image"
      @error="mark_feed_failed"
      @load="mark_feed_loaded"
    />

    <div
      v-if="is_loading"
      class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center
             justify-content-center text-center p-4 bg-dark bg-opacity-75 text-white"
    >
      <div>
        <div class="spinner-border spinner-border-sm mb-3" role="status" aria-hidden="true"></div>
        <p class="fw-semibold mb-1">{{ feed_status_title }}</p>
        <p class="text-xs mb-0">{{ feed_status_message }}</p>
      </div>
    </div>

    <div
      v-if="should_show_empty_state"
      class="live-feed-empty d-flex align-items-center justify-content-center text-center p-4"
    >
      <div>
        <i class="bi bi-camera-video-off fs-2 d-block mb-2"></i>
        <p class="fw-semibold mb-1">{{ feed_status_title }}</p>
        <p class="text-xs mb-0">{{ feed_status_message }}</p>
      </div>
    </div>
  </div>

  <div class="mt-3 pt-3 border-top d-flex align-items-center justify-content-between gap-3">
    <div class="min-w-0">
      <small class="text-uppercase text-secondary text-xxs fw-bold d-block mb-1">Linked Coordinates</small>
      <p class="text-xs fw-semibold mb-0 text-truncate">{{ coordinate_label }}</p>
    </div>

    <button
      type="button"
      class="btn btn-sm btn-outline-danger rounded-circle d-inline-flex align-items-center
             justify-content-center flex-shrink-0"
      title="Refresh live feed"
      @click="refresh_feed"
    >
      <i class="bi bi-arrow-clockwise"></i>
    </button>
  </div>
</article>
